import { Component } from '@angular/core';
import { FtSearchService } from './ftsearch.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  results = [];
  title = 'ftsearch';
  loading = false;
  notFound = false;

  constructor(private ftsearch: FtSearchService) {}

  onTerm(term: string) {
    this.notFound = false;
    this.loading = true;

    this.ftsearch.search(term).subscribe((response) => {
      this.loading = false;
      if (response.length === 0 ) {
        this.notFound = true;
        return;
      }
      this.results = response;
    });

  };
  
  onClearResults() {
    this.results = [];
    this.notFound = false;
    this.loading = false;
  }
}